import Live from "./../Pages/Live";
import Device from "./../Pages/Device";
import Appliance from "./../Pages/Device/Appliance";
import Search from "./../Pages/Search";
import Insight from "./../Pages/Insight";
import AddAppliance from "../Pages/AddAppliance";
import AddCamera from "../Pages/AddCamera";
import Settings from "../Pages/Settings";
import AddUser from "../Pages/AddUser";
import UserManage from "../Pages/UserManage";
import EditAppliance from "../Pages/EditAppliance";

import Story from "../Pages/Story";
import Case from "../Pages/Case";
import Alert from "../Pages/Alert";
import CreateAlert from "../Pages/CreateAlert";
import EditAlert from "../Pages/EditAlert";

const routes = {
  type1: [
    {
      path: "/live",
      element: <Live />,
    },
    {
      path: "/device",
      element: <Device />,
    },
    {
      path: "/device/appliance",
      element: <Appliance />,
    },
    {
      path: "/search",
      element: <Search />,
    },
    {
      path: "/insight",
      element: <Insight />,
    },
    {
      path: "/registerAppliance",
      element: <AddAppliance />,
    },
    {
      path: "/addCamera",
      element: <AddCamera />,
    },
    {
      path: "/settings",
      element: <Settings />,
    },
    {
      path: "/addUser",
      element: <AddUser />,
    },
    {
      path: "/userManage",
      element: <UserManage />,
    },
    {
      path: "/editAppliance/:id",
      element: <EditAppliance />,
    },
  ],
  type2: [
    {
      path: "/story",
      element: <Story />,
    },
    {
      path: "/case",
      element: <Case />,
    },
    {
      path: "/alert",
      element: <Alert />,
    },
    {
      path: "/createAlert",
      element: <CreateAlert />,
    },
    {
      path: "/editAlert",
      element: <EditAlert />,
    },
  ],
  type3: [],
};

export default routes;
